export enum GooglePaymentMethodTypesEnum {
  AMEX = 'AMEX',
  DISCOVER = 'DISCOVER',
  JCB = 'JCB',
  MASTERCARD = 'MASTERCARD',
  VISA = 'VISA',
  INTERAC = 'INTERAC',
  OTHER = 'OTHER',
}
